import { render } from "./AdminHome.vue?vue&type=template&id=531fffcb"
import script from "./AdminHome.vue?vue&type=script&lang=js"
export * from "./AdminHome.vue?vue&type=script&lang=js"
script.render = render

export default script